/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import * as React from 'react';

export interface IBusinessSignUpRadioButtonProps {
    id: string;
    isRequired: boolean;
    options: IBusinessSignUpRadioButtonOptionProps[];
}

export interface IBusinessSignUpRadioButtonOptionProps {
    id: string;
    name: string;
    value: string;
    label: string;
    className: string;
    onChange(event: React.ChangeEvent<HTMLInputElement>): void;
}

// MTT extension start
export const BusinessSignUpRadioButtonOption: React.FC<IBusinessSignUpRadioButtonOptionProps & { selected: string }> = props => {
    const { id, name, value, label, className, onChange, selected } = props;
    // MTT extension end
    return (
        <div className={className}>
            {/* MTT extension start */}
            <input type='radio' id={id} name={name} value={value} onChange={onChange} checked={selected === value} />
            {/* MTT extension end */}
            <label htmlFor={id}>{label}</label>
        </div>
    );
};

export default BusinessSignUpRadioButtonOption;
